import React, { useEffect, useRef, useState } from 'react'
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import { Container } from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import SIPartnerRegistrationForm from './SIPartnerRegistrationForm';
import "./SIPartnerRegistration.css";

const SIPartnerRegistration = () => {
  const revealRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Entrance animation: runs once when the form scrolls into view (never replays)
  useEffect(() => {
    const node = revealRef.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.05 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <UpdatesBanner
        className="agrocare-marketplace-bg si-hero"
        bannerTitle={["Tell us about the ecosystem you want to operate as an Ecosystem Network Operator"]}
      />

      <section className="si-reg-section" id="AgentForm">
        <Container className="subSectionWrapper si-reg-container">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <div
                ref={revealRef}
                className={`si-reveal${isVisible ? " is-visible" : ""}`}
              >
                <SIPartnerRegistrationForm />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default SIPartnerRegistration
